import { ComponentRef, EventEmitter, Injectable, Provider, ViewContainerRef } from "@angular/core";
import { CpxCardInterface } from "src/app/utils/interfaces/new/cpx-card-interface";
import { LectureCarteVitale, CheckVitaleStatus, VitaleInfos } from "src/app/utils/interfaces/new/lecture-carte-vitale";
import { CannotOpenSession,
  CannotReadCpx,
  CannotReadVitale,
  CpxCard, CpxCardRipped,
  ExpiredCardError,
  MultipleCpxCards,
  MultipleVitaleCards,
  NoCPXCard,
  NoVitaleCard,
  TooManyPinCodeError,
  VitaleCardRipped,
  WrongPinCode } from "./cpx-handle.error";
import { CardInfos, CardRippedStatus, CpxHandleServiceAbstract, SessionTypeEnum, TypeConnecteurEnum, WirelessModeCardType, dmpTypeConnexionInteropSettingKey, insiTypeConnexionInteropSettingKey } from "./cpx-handle-service-abstract";
import { CpxApiErrorService } from "./cpx-api-error.service";
import { CpxCardTypeEnum } from "src/app/utils/interfaces/new/cpx-card-type-enum";
import { CpxCardSignatureResponseInterface, CpxCardSignatureResponsePracticeLocationsInterface } from "src/app/utils/interfaces/new/cpx-signature-response-interface";
import { CpxCardInfoStatus, CpxCardSignature, CpxSessionInterface, CpxTypeEnum } from "src/app/utils/interfaces/new/cpx-session.interface";
import { environment } from "src/environments/environment";
import { RessourceService } from "../ressource/ressource.service";
import { LectureIns } from "src/app/utils/interfaces/new/lecture-ins.interface";
import { ModalService } from "../modal/modal.service";
import { HandleCpxModalComponent } from "src/app/fragments/modal/handle-cpx-modal/handle-cpx-modal.component";
import { CannotCreateInsiConnector, MultipleIdentitiesFound, NoIdentityFound, NotSameVitaleCard } from "../ins/ins.error";
import { SnackbarService } from "../snackbar/snackbar.service";
import { LoginService } from "../login/login.service";
import { Profil } from "src/app/utils/interfaces/new/profil.interface";
import { UserService } from "../user/user.service";
import { ReferentielService } from "../referentiel/referentiel.service";
import { StringUtilsService } from "../string-utils/string-utils.service";
import { nomSettingKey, nomStructureSettingKey, prenomSettingKey, professionSettingKey, specialiteSettingKey, typeStructureSettingKey } from "../dmp/dmp.service";
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, LogObject, ResultEnum, TypeTargetEnum } from "../log-fonctionnel/log-fonctionnel.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CurrentSession, SessionService } from "./connecteur-dinno/models";
import { FeatureKey, FeatureService } from "../feature/feature.service";
import { ProfilService } from "../profil/profil.service";
import { StellairService } from "../stellair/stellair.service";
import { EdcAuthService } from "../auth/edc-auth.service";

declare const DMPConnect: any;
const SESSION_TIMEOUT_IN_SECONDS = 1200; // 1200
export const WIRELESS_MODE_CPX_CARD_NAME = 'WIRELESS CPX';
export const WIRELESS_MODE_VITALE_CARD_NAME = 'WIRELESS VITALE';

const DO_RETRY_FUNCTION = 'DO_RETRY_FUNCTION';
export class DoRetryError extends Error {
  constructor() {
      super(DO_RETRY_FUNCTION);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = DoRetryError.name;
  }
}

export type DinnoSession = CurrentSession;
interface RawCpxApiError {
  i_apiErrorType: number;
  i_apiErrorCode: number;
  s_apiErrorDescription: string;
  s_apiErrorContext: string;
  s_apiErrorExtendedInformations: string;
  s_apiErrorDmpErrorCode: string;
  s_apiErrorDmpErrorDetails: string;
  s_apiErrorTypeDescription: string;
}

const practiceSettingKey = 'dmp_params_practice_setting';

interface SessionMapInterface {
  sessionInfos: CpxSessionInterface;
  session: any;
}


@Injectable({
  providedIn: 'root'
})
export class CpxHandleService extends CpxHandleServiceAbstract {

  // private _vitaleSessionId: string;
  // private _vitaleSession: any;
  // private _cpxSession: CpxSessionInterface;

  public cpxCardRipped = new EventEmitter<CardRippedStatus>();

  private LpsInfos = {
    s_idam: environment.iCanopeeIdam,
    s_numAM: environment.iCanopeeNumAM,
    s_version: environment.iCanopeeVersion,
    s_instance: environment.iCanopeeInstance,
    s_name: environment.iCanopeeName,
    s_billingNumber: environment.iCanopeeBillingNumber
  };

  private _modal: ComponentRef<HandleCpxModalComponent>;
  private modalSuppInfos: string | undefined = undefined;

  private dinnoSession: DinnoSession = undefined;

  private _sessionsMap: Map<SessionTypeEnum, SessionMapInterface> = new Map<SessionTypeEnum, SessionMapInterface>();

  private set _cpxCardType(type: CpxTypeEnum) {
    this.cpxCardTypeEmmitter.emit(type);
  };
  public cpxCardTypeEmmitter = new EventEmitter<CpxTypeEnum>();

  public cpxCardInfos: BehaviorSubject<CardInfos> = new BehaviorSubject<CardInfos>(this._getCardInfos());
  private set cardInfos(session: CpxSessionInterface) {
    this.cpxCardInfos.next(this._getCardInfos(session));
  }

  private _getCardInfos(session?: CpxSessionInterface) {
    if (
      session && session.cpxType && session.psName && session.psGiven
      && (session.practiceSettingIndice || session.practiceSettingIndice === 0) && session.PracticeLocations && session.PracticeLocations[session.practiceSettingIndice]?.s_practiceLocationName
      ) {
      return {
        type: session.cpxType,
        user: `${session.psName} ${session.psGiven}`,
        cabinet: `${session.PracticeLocations[session.practiceSettingIndice]?.s_practiceLocationName}`,
      };
    } else {
      return undefined;
    }
  }

  constructor(
    private _cpxErrorSrv: CpxApiErrorService,
    private _resourceSrv: RessourceService,
    private _modalService: ModalService,
    private _snckBrSrv: SnackbarService,
    private _userSrv: UserService,
    private _refSrv: ReferentielService,
    private _strUtilsSrv: StringUtilsService,
    private _logSrv: LogFonctionnelService,
    private _dinnoSessionSrv: SessionService,
    private _featureSrv: FeatureService,
    private _stellairSrv: StellairService,
    private _edcAuthSrv: EdcAuthService,
    private _profilSrv: ProfilService,
  ) {
    super();

    this._sessionsMap.set(SessionTypeEnum.CARTE, { session: this._getNewDmpInstance(SessionTypeEnum.CARTE), sessionInfos: undefined });
    this._sessionsMap.set(SessionTypeEnum.CERT_DMP, { session: this._getNewDmpInstance(SessionTypeEnum.CERT_DMP), sessionInfos: undefined });
    this._sessionsMap.set(SessionTypeEnum.CERT_INSI, { session: this._getNewDmpInstance(SessionTypeEnum.CERT_INSI), sessionInfos: undefined });
  }

  private async _openSessionDmpConnect(sessionType: SessionTypeEnum): Promise<any> {
    try {
      const dcParam = environment.cpxLicenseBase64;
      if (sessionType === SessionTypeEnum.CERT_DMP || sessionType === SessionTypeEnum.CERT_INSI) {
        const command = {
          "s_commandName"      : "hl_openSession",
          "i_timeoutInSeconds" : SESSION_TIMEOUT_IN_SECONDS,
          "s_dcparameters64"   : dcParam,
          "s_esConfig64" : await this._getCertificatEtablissement(sessionType)
        };

        const wrapperCallback = (self) => {
          return function(result) {
            if (result.s_status == 'OK') {
                self._sessionId = result.s_sessionId;
                self.setState('session', true);
                self._refreshCallback();
            }
          }
        }
        return await new Promise((resolve, reject) => {
          this._sessionsMap.get(sessionType).session.sendCommand(command, 30,
            (response) => {
              if (response.error) {
                reject(response.error);
              } else {
                this._setCpxSession(CpxTypeEnum.CERTIFICAT, undefined, undefined,
                undefined, response.PracticeLocations, response.s_given, response.s_name, undefined, sessionType);
                resolve(response);
              }
            },
            false,
            wrapperCallback(this._sessionsMap.get(sessionType).session));
        });
      } else {
        return await new Promise(async (resolve, reject) => {
          await this._registerDcParameter(sessionType);
          this._sessionsMap.get(sessionType).session.hl_openSessionWithCustomDcParam(dcParam, SESSION_TIMEOUT_IN_SECONDS, undefined, (response) => {
            if (response.error) {
              reject(response.error);
            } else {
              this._setCpxSession(CpxTypeEnum.CPS, undefined, undefined,
              undefined, response.PracticeLocations, response.s_given,
              response.s_name, undefined, sessionType);
              resolve(response);
            }
          });
        });
      }
    } catch (e) {
      throw e;
    }

  }

  private async _registerDcParameter(sessionType: SessionTypeEnum): Promise<void> {
    const command = {
      "s_dcparameters64"   : environment.cpxLicenseBase64,
    };

    try {
      const isRegistered = await new Promise<boolean>((resolve, reject) => {
        this._sessionsMap.get(sessionType).session.sendHttpCommand(
          command,
          "isDcParameterRegistered",
          (e) => {
            if (e.error) {
              reject(e);
            } else {
            console.log(e);
            resolve(!!e.i_registered);
          }
        });
      });

      if (!isRegistered) {
        await new Promise<any>((resolve, reject) => {
          this._sessionsMap.get(sessionType).session.sendHttpCommand(
            command,
            "registerDcParameter",
            (e) => {
              if (e.error) {
                reject(e);
              } else {
              console.log(e);
              resolve(undefined);
            }
          });
        });
      }
    } catch (e) {
      throw e;
    }
  }

  private async _getInstanceByType(type: SessionTypeEnum, connecteur?: TypeConnecteurEnum): Promise<any> {
    if (!connecteur || connecteur === TypeConnecteurEnum.DMPConnect) {
      // On teste la session DmpConnect locale et non isSessionOpen : avec l'API REST active,
      // isSessionOpen(CARTE) reflète la session Espace de Confiance alors que la lecture des cartes reste locale.
      if (!await this._isDmpConnectSessionOpen(type)) {
        // if (type === SessionTypeEnum.CARTE) {
        //   if (await this.isSessionInstanciate(type)) {
        //     await _openSession(type);
        //   }
        // } else {
        //   await _openSession(type);
        // }
        if (!await this.isSessionInstanciate(type)) {
          try {
            const result = await this._openSessionDmpConnect(type);
            console.log(result);
          } catch (e) {
            throw e;
          }
        }
        // await _openSession(type);
        return this._sessionsMap.get(type).session;
      } else {
        return this._sessionsMap.get(type).session;
      }
    }
  }

  public setInsiConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated = false): void {
    try {
      if (connecteur === TypeConnecteurEnum.DMPConnect && this._sessionsMap.has(type)) {
        this._sessionsMap.get(type).sessionInfos.isInsiConnectorCreated = isCreated;
      }
    } catch (e) {
      // TODO Do smoething here...
    }
  }

  public setDmpConnectorIsCreated(type: SessionTypeEnum, connecteur: TypeConnecteurEnum, isCreated = false): void {
    try {
      if (connecteur === TypeConnecteurEnum.DMPConnect && this._sessionsMap.has(type)) {
        this._sessionsMap.get(type).sessionInfos.isDmpConnectorCreated = isCreated;
      }
    } catch (e) {
      // TODO Do smoething here...
    }
  }

  /**
   * Indique si une modale d'authentification CPS/PSC est actuellement affichée à l'écran.
   * Permet aux processus passifs en arrière-plan (ex: checklist DICA, vérifications d'état)
   * de savoir s'il est sûr d'exécuter des opérations ou s'ils doivent s'abstenir pour ne pas
   * entrer en conflit avec une action utilisateur en cours.
   */
  public isModalOpen(): boolean {
    return !!this._modal;
  }

  /**
   * Sécurité multi-instances :
   * Si une modale est déjà active, l'ouverture d'une deuxième modale en parallèle est
   * immédiatement bloquée. Cela évite le gel de l'interface et les blocages au niveau
   * de Cryptolib/lecteur CPS provoqués par des appels concurrents (ex: vérification INSi
   * en cours pendant qu'un autre service tente une authentification automatique).
   */
  public async showCpxModal(view: ViewContainerRef, connecteur?:TypeConnecteurEnum): Promise<{isSessionOpen: boolean}> {
    return new Promise<{isSessionOpen: boolean}>(async(resolve) => {

      if (this._modal) {
        resolve({ isSessionOpen: false });
        return;
      }

      // await this.closeSession(SessionTypeEnum.CARTE);

      this._modal = this._modalService.openModal<HandleCpxModalComponent>(
        view,
        HandleCpxModalComponent
      ) as ComponentRef<HandleCpxModalComponent>;

      if (connecteur) {
        this._modal.instance.typeConnecteur = connecteur;
      }

      if (this.modalSuppInfos) {
        this._modal.instance.moreInfoOnLoginNeed = this.modalSuppInfos;
        this.modalSuppInfos = undefined;
      }

      // TEST
      const res = await new Promise<any>(async (resolve) => {
        let sub = this._modal.instance.closeEmitterHandleCpx.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
          sub = undefined;
          this._modal.destroy();
          this._modal = undefined;
        });
      });
      if (!connecteur || connecteur === TypeConnecteurEnum.DMPConnect) {
        if (res && this._sessionsMap.get(SessionTypeEnum.CARTE)?.sessionInfos) {
          this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.dmpConnectSessionInfos = res.data;
        }

        if (!res || !res.data) {
          if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos) {
            // this._cpxSession.practiceSettingIndice = undefined
            // this._cpxSession.practiceSettingIndice = null;
            this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = undefined;
            this.cardInfos = undefined;
          }
          this._sessionsMap.delete(SessionTypeEnum.CARTE);
          this._sessionsMap.set(SessionTypeEnum.CARTE, { session: this._getNewDmpInstance(SessionTypeEnum.CARTE), sessionInfos: undefined });
          resolve({ isSessionOpen: false });
        } else {
          const test = await this.isSessionInstanciate(SessionTypeEnum.CARTE);
          resolve({ isSessionOpen: res && res.data && test });
        }
        this.cardInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;
      } else {
        if(res && res.data && res.data.slotId != null && res.data.situation && res.pinCode) {
          const openSession = await this._dinnoSessionSrv.openSession({
            ins: "",
            oid: "",
            slot: res.data.slotId,
            pin: res.pinCode,
            situationCourante: res.data.situation,
            modeSecret: false,
            identiteUtilisateur: "",
          }).toPromise();
          this.dinnoSession = await this._dinnoSessionSrv.getCurrentSession().toPromise();
          resolve({ isSessionOpen: true });
        } else {
          resolve({ isSessionOpen: false });
        }
      }
      // TEST

      // let sub = this._modal.instance.closeEmitterHandleCpx.subscribe(async (res) => {
      //   if (!connecteur || connecteur === TypeConnecteurEnum.DMPConnect) {
      //     if (res && this._sessionsMap.get(SessionTypeEnum.CARTE)?.sessionInfos) {
      //       this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.dmpConnectSessionInfos = res.data;
      //     }

      //     if (!res || !res.data) {
      //       if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos) {
      //         // this._cpxSession.practiceSettingIndice = undefined
      //         // this._cpxSession.practiceSettingIndice = null;
      //         this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = undefined;
      //         this.cardInfos = undefined;
      //       }
      //       this._sessionsMap.delete(SessionTypeEnum.CARTE);
      //       this._sessionsMap.set(SessionTypeEnum.CARTE, { session: this._getNewDmpInstance(SessionTypeEnum.CARTE), sessionInfos: undefined });
      //       resolve({ isSessionOpen: false });
      //     } else {
      //       resolve({ isSessionOpen: res && res.data && await this.isSessionInstanciate(SessionTypeEnum.CARTE) });
      //     }
      //     this.cardInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;
      //     sub.unsubscribe();
      //     sub = undefined;
      //     this._modal.destroy();
      //     this._modal = undefined;
      //   } else {
      //     if(res && res.data && res.data.slotId != null && res.data.situation && res.pinCode) {
      //       const openSession = await this._dinnoSessionSrv.openSession({
      //         ins: "",
      //         oid: "",
      //         slot: res.data.slotId,
      //         pin: res.pinCode,
      //         situationCourante: res.data.situation,
      //         modeSecret: false,
      //         identiteUtilisateur: "",
      //       }).toPromise();
      //       this.dinnoSession = await this._dinnoSessionSrv.getCurrentSession().toPromise();
      //       resolve({ isSessionOpen: true });
      //     } else {
      //       resolve({ isSessionOpen: false });
      //     }
      //     sub.unsubscribe();
      //     sub = undefined;
      //     this._modal.destroy();
      //     this._modal = undefined;
      //   }
      // });
    });
  }

  public get getPracticeSettingIndice(): number | undefined {
    return this._sessionsMap.get(SessionTypeEnum.CARTE)?.sessionInfos?.practiceSettingIndice;
  }

  public async lectureESCertificate(view: ViewContainerRef, type?: SessionTypeEnum) {
    try {
      await this._openSession(type);
    } catch (error) {
      throw new CannotOpenSession("Pas de session, impossible de récuperer le certificat ES");
    }
  }

  private _vitaleLectureInfos: { readers: any, cardName: string, type: SessionTypeEnum };
  /**
   * Réponse brute de la dernière lecture de carte Vitale (hl_readVitaleCard).
   * Réutilisée par la stratégie INSi REST, qui ne peut pas lire la carte elle-même.
   */
  private _lastVitaleRead: LectureCarteVitale;

  public getLastVitaleRead(): LectureCarteVitale | undefined {
    return this._lastVitaleRead;
  }

  /**
   * Informations techniques de la dernière carte Vitale lue, dont son numéro de série (hl_getVitaleInfos).
   * La carte doit avoir été lue au préalable (lectureVitale).
   *
   * @param vitaleIndex Position du bénéficiaire dans le tableau Patients de la lecture
   */
  public async getVitaleInfos(vitaleIndex: number): Promise<VitaleInfos | undefined> {
    if (!this._vitaleLectureInfos) {
      return undefined;
    }

    const instance = await this._getInstanceByType(this._vitaleLectureInfos.type);
    return new Promise<VitaleInfos>((resolve, reject) => {
      instance.hl_getVitaleInfos({ i_vitalePatientIndex: vitaleIndex }, (response) => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(response);
        }
      });
    });
  }

  /**
   * Vérifie que la carte Vitale présente dans le lecteur est celle de la dernière lecture.
   * Retourne false si aucune carte n'a été lue ou si la vérification échoue.
   */
  public async isSameVitaleCard(): Promise<boolean> {
    if (!this._vitaleLectureInfos || !this._lastVitaleRead) {
      return false;
    }

    try {
      const isSame = await this._checkIfLastVitaleIsTheSame(this._vitaleLectureInfos.type);
      if (!isSame) {
        this._lastVitaleRead = undefined;
      }
      return isSame;
    } catch (e) {
      console.error(e);
      this._lastVitaleRead = undefined;
      return false;
    }
  }

  public async lectureVitale(view: ViewContainerRef, slotName?: string): Promise<LectureCarteVitale> {
    let type = SessionTypeEnum.CARTE;
    try {
      if (await this.isESConnexionIndirect(SessionTypeEnum.CERT_INSI)) {
        type = SessionTypeEnum.CERT_INSI;
      }
    } catch (e) {
      throw e;
    }

    try {
      // await this._openSession(type);
      const readers = await this._getPcscReaders(type);
      const readCards = await this._getNBVitaleCard(readers["Readers"]);
      if (readers["Readers"] && readers["Readers"].length === 1 && readCards.vitale === 0 && readCards.cps >= 1) {
        throw new CpxCard();
      } else if (readCards.vitale === 0) {
        throw new NoVitaleCard();
      } else if (readCards.vitale === 1) {
        const cardsVitale = await this._getVitaleCards(readers["Readers"]);
        const card = cardsVitale[0];
        this._vitaleLectureInfos = { readers: readers["Readers"], cardName: card.s_name, type: type };
        const rtd = await this._readVitaleCard(this._vitaleLectureInfos.readers, this._vitaleLectureInfos.cardName, this._vitaleLectureInfos.type);
        return rtd;
      } else {
        const cardsVitale = await this._getVitaleCards(readers["Readers"]);
        for (let card of cardsVitale) {
          if (card.s_name === slotName) {
            this._vitaleLectureInfos = { readers: readers["Readers"], cardName: card.s_name, type: type };
            const rtd = await this._readVitaleCard(this._vitaleLectureInfos.readers, this._vitaleLectureInfos.cardName, this._vitaleLectureInfos.type);
            return rtd;
          }
        }
        const names = cardsVitale.map((cardInfos) => (cardInfos.s_name));
        throw new MultipleVitaleCards(names.toString());
      }
    } catch (e) {
      if (e instanceof DoRetryError) {
        return await this.lectureVitale(view, slotName);
      } else {
        throw e;
      }
    }
  }

  public async checkVitaleStatus(view: ViewContainerRef, slotName?: string): Promise<CheckVitaleStatus | undefined> {
    let type = SessionTypeEnum.CARTE;
    try {
      if (await this.isESConnexionIndirect(SessionTypeEnum.CERT_INSI)) {
        type = SessionTypeEnum.CERT_INSI;
      }
    } catch (e) {
      throw e;
    }
    return await this._cvStatus(type);
  }


  public async getCpxCardStatus(view: ViewContainerRef, type?: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<CpxCardInfoStatus> {
    if (!await this.getCpxSession(view, type, connecteur)) {
      throw new CannotOpenSession("Pas de session, impossible de récuper le statut de la carte");
    }
    return await new Promise<CpxCardInfoStatus>(async (resolve, _) => {
      (await this._getInstanceByType(SessionTypeEnum.CARTE)).hl_getCpxStatus((response) => {
        resolve(response)
      });
    });
  }

  private async _cvStatus(type: SessionTypeEnum): Promise<CheckVitaleStatus | undefined> {
    if (!await this.isWirelessMode(type)) {
      return new Promise<CheckVitaleStatus>(async (resolve, _) => {
        (await this._getInstanceByType(type)).hl_checkVitaleTokenStatus(undefined, (result: CheckVitaleStatus) => {
          resolve(result);
        });
      });
    } else {
      return undefined;
    }
  }

  public async signWithCpx(view: ViewContainerRef, data: string, pincode: string, authSign=false, type?: SessionTypeEnum, connecteur?:TypeConnecteurEnum): Promise<CpxCardSignature> {
    if (!await this.getCpxSession(view, type, connecteur)) {
      throw new CannotOpenSession("Pas de session, impossible de signer avec la carte");
    }
    return await new Promise<CpxCardSignature>(async (resolve, reject) => {
      (await this._getInstanceByType(SessionTypeEnum.CARTE))
        .hl_signWithCpxCard(pincode, data, undefined, (response) => {
          if (response.error) {
            reject(response.error);
          } else {
            resolve(response);
          }
      });
    });
  }

  private _isWirelessModeVar: boolean = undefined;
  public async isWirelessMode(type: SessionTypeEnum): Promise<boolean> {
    if (window.location.href.includes(`${environment.sitePath}/login`)) {
      return false;
    }

    if (this._isWirelessModeVar !== undefined) {
      return this._isWirelessModeVar;
    }

    const isStellairFeatureEnabled = await this._featureSrv.canUseFeature(FeatureKey.STELLAIR);
    if (!isStellairFeatureEnabled) {
      this._isWirelessModeVar = false;
      return this._isWirelessModeVar;
    }

    return new Promise<boolean>(async (resolve, reject) => {
      try {
        (await this._getInstanceByType(type)).hl_isWirelessModeEnabled({}, (response) => {
          if (response.error) {
            if (this.isErrorEndSession(response, type)) {
              reject(new DoRetryError());
            } else {
              reject(response.error);
            }
          } else {
            this._isWirelessModeVar = !!response.i_enabled;

            if (isStellairFeatureEnabled && !this._isWirelessModeVar) {
              this._snckBrSrv.openSnackBar(
                "Vous avez-accès au mode sans-fil Stellair mais le service DmpConnect n'est pas configuré.\nVeuillez contacter le support technique Hypermed pour accéder à cette fonctionnalité.",
                undefined, undefined,
                10000
              );
            }

            resolve(this._isWirelessModeVar);
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async updateCpxAuthenticationToken(cardType: WirelessModeCardType, authToken: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this.isWirelessMode(SessionTypeEnum.CARTE)) {
          resolve();
          return;
        }

        if (cardType === WirelessModeCardType.CPX) {
          await this._getCpxCard(WIRELESS_MODE_CPX_CARD_NAME, 0);
        } else if (cardType === WirelessModeCardType.VITALE) {
          await this._getCpxCard(WIRELESS_MODE_VITALE_CARD_NAME, 1);
        }

        (await this._getInstanceByType(SessionTypeEnum.CARTE)).hl_updateCpxAuthenticationToken(authToken, (response) => {
          if (response.error) {
            if (this.isErrorEndSession(response, SessionTypeEnum.CARTE)) {
              reject(new DoRetryError());
            } else {
              reject(response.error);
            }
          } else {
            resolve();
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async lectureCpxCard(slotName?: string): Promise<CpxCardInterface> {
    if (!await this.isSessionOpen(SessionTypeEnum.CARTE)) {
      try {
        await this._openSession(SessionTypeEnum.CARTE);
      } catch (e) {
        console.error(e);
        throw new CannotOpenSession();
      }
    }

    // await this.isWirelessMode(SessionTypeEnum.CARTE);

    const readers = await this._getPcscReaders(SessionTypeEnum.CARTE);
    const cpxCards = await this._getCpxCards(readers['Readers']);

    if (slotName && slotName !== '') {
      return cpxCards.find(s => s.s_name === slotName);
    } else {
      if (cpxCards.length > 1) {
        const slots: Array<string> = [];
        for (const c of cpxCards) {
          slots.push(c.s_name);
        }
        throw new MultipleCpxCards(slots);
      } else if (cpxCards.length === 1) {
        return cpxCards[0];
      } else if (cpxCards.length === 0) {
        throw new NoCPXCard();
      }
    }
  }

  public async getInstance(view: ViewContainerRef, type?: SessionTypeEnum): Promise<any> {
    if (!await this.isSessionOpen(type)) {
      try {
        if (type && await this.isESConnexionIndirect(type)) {
          const loading = this._modalService.openLoading(view);
          try {
            await this._openSession(type);
          } catch (e) {
            this._modalService.openAlert(view,
              "Erreur",
              "Une erreur est survenue lors de la connexion en mode indirect. Veuillez réessayer ultérieurement.",
              undefined,
              e.toString());
          } finally {
            loading.destroy();
          }
        } else {
          await this.showCpxModal(view);
        }
      } catch (e) {
        console.error(e);
        throw new CannotOpenSession();
      }
    }

    if (await this.isSessionOpen(type)) {
      return await this._getInstanceByType(type);
    } else {
      return undefined;
    }
  }

  public async readCpx(slotName: string, pinCode: string): Promise<any> {
    const readers = await this._getPcscReaders(SessionTypeEnum.CARTE);
    const cpxCards = await this._getCpxCards(readers['Readers']);

    await this._readCpxCard(cpxCards, slotName);

    return await new Promise<any>(async (resolve, reject) => {
      (await this._getInstanceByType(SessionTypeEnum.CARTE)).hl_readCpxCard(pinCode, (response) => {
        if (response.error) {
          if ((response.error as RawCpxApiError).i_apiErrorType === 1 && (response.error as RawCpxApiError).i_apiErrorCode === 8) {
            reject(new TooManyPinCodeError());
          } else if ((response.error as RawCpxApiError).i_apiErrorType === 1 && (response.error as RawCpxApiError).i_apiErrorCode === 7) {
            reject(new WrongPinCode());
          } else if ((response.error as RawCpxApiError).i_apiErrorType === 1 && (response.error as RawCpxApiError).i_apiErrorCode === 5) {
            reject(new ExpiredCardError(`Carte expirée`));
          } else {
            reject(this._cpxErrorSrv.getError(response.error));
          }
        } else {
          response = response as CpxCardSignatureResponseInterface;
          const type = this._getCardTypeLabel(response.i_cpxType) as 'CPS' | 'CPE' | 'CPF';

          console.log('readCpx - type : ', type);

          const monitoring = this._startMonitoring();

          this._setCpxSession(type as CpxTypeEnum, slotName, pinCode,
            monitoring, response.PracticeLocations, response.s_given, response.s_name, undefined, SessionTypeEnum.CARTE);
          // this._setCpxSession(this._cpxSessionId, type, slotName, pinCode,
            // undefined, response.PracticeLocations, response.s_given, response.s_name);
          resolve(response);
        }
      });
    });
  }

  public selectPracticeSettingIndice(indice: number): void {
    if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos) {
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice = indice;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;
    }
  }

  public setPracticeSetting(practiceSetting: any): void {
    if (this._sessionsMap.get(SessionTypeEnum.CARTE)?.sessionInfos?.PracticeLocations) {
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0].s_practiceLocationName = practiceSetting.nomStructure;
      (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0] as any).s_practiceLocationActivitySector = practiceSetting.typeStructure;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0].s_practiceLocationActivity = practiceSetting.typeStructure;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0].s_practiceLocationStructureId = practiceSetting.idNatStructure;
      (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0] as any).s_practiceLocationPracticeSettings = practiceSetting.activite;
      (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[0] as any).s_practiceLocationBillingNumber = undefined;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice = 0;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;

      if (practiceSetting.specialite) {
        (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos as any).Hp = { s_specialty: practiceSetting.specialite };
      }
    }
  }

  public async getPracticeLocationActivity(): Promise<{pinCode?: string, practiceLocationActivity: string, practiceSettingIndice?: number} | undefined>{
    return new Promise<{pinCode?: string, practiceLocationActivity: string, practiceSettingIndice?: number} | undefined>(async (resolve, reject) => {
      try {
        const isEs = await this.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
        const type = isEs ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
        let rtd: {pinCode?: string, practiceLocationActivity: string, practiceSettingIndice?: number} | undefined = undefined;
        if (type === SessionTypeEnum.CARTE) {
          if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos && this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations && (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice || this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice === 0) && (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice].s_practiceLocationActivity || (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice] as any).s_practiceLocationActivitySector)) {
            rtd = {
              pinCode: this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.pinCode,
              practiceSettingIndice: this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice,
              practiceLocationActivity: this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.PracticeLocations[this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.practiceSettingIndice].s_practiceLocationActivity,
            };
          }
        } else {
          const profil = (JSON.parse(localStorage.getItem('currentProfil')) as Profil);
          if (profil && profil.id) {
            const resources = await this._resourceSrv.getResourceSettings(profil.id, 'profil');
            const psl = resources.find(r => r.settingKey === 'dmp_params_typestruct_setting');
            if (psl && psl.settingValue) {
              rtd = {
                practiceLocationActivity: psl.settingValue
              };
            }
          }
        }
        resolve(rtd);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  // APE : BAHHHHHHHHHH le any (pour connecteur dinno), à changer TODO
  // Any = CurrentSession
  public async getCpxSession(view: ViewContainerRef, type?: SessionTypeEnum, connecteur?: TypeConnecteurEnum): Promise<CpxSessionInterface | any | undefined> {
    if (!connecteur || connecteur == TypeConnecteurEnum.DMPConnect) {
      const isRest = await this._profilSrv.useEdcRestProxy();
      if (isRest && type === SessionTypeEnum.CARTE) {
        const profil = (JSON.parse(localStorage.getItem('currentProfil')) as Profil);
        const rpps = profil?.rpps || '899700741871';
        const psName = profil?.utilisateur?.nom || 'Nom';
        const psGiven = profil?.utilisateur?.prenom || 'Prénom';

        if (!this._edcAuthSrv.s_correlationId || this._edcAuthSrv.s_correlationId === 'test-correlation-id') {
          try {
            await this._edcAuthSrv.connectUser(rpps, view);
          } catch (e) {
            console.error("Erreur d'authentification CodeFlow REST:", e);
            return undefined;
          }
        }

        // Exercice et cadre d'exercice sélectionnés lors de l'authentification EdC (cf. EdcAuthService.connectUser).
        // On part du principe qu'un PS n'a qu'un seul exercice.
        const exercice = this._edcAuthSrv.exercice;
        const activity = this._edcAuthSrv.selectedActivity;
        const subjectRole = this._edcAuthSrv.subjectRole;
        const professionOid = subjectRole?.length > 0 ? subjectRole[0].split('^')[1] : undefined;

        const practiceLocation = {
          s_practiceLocationActivity: activity?.codeSecteurDactivite,
          s_practiceLocationName: activity?.raisonSocialeSite,
          s_practiceLocationStructureId: activity?.identifiantTechniqueDeLaStructure
        } as any;

        const virtualSession: CpxSessionInterface = {
          cpxType: CpxTypeEnum.CPS,
          pinCode: '',
          name: `${psName} ${psGiven}`,
          monitoring: undefined as any,
          PracticeLocations: [practiceLocation],
          practiceSettingIndice: 0,
          cardStatus: undefined as any,
          psGiven: psGiven,
          psName: psName,
          isSessionOpen: true,
          confidentialityLevel: false,
          dmpConnectSessionInfos: {
            s_internalId: rpps,
            s_given: exercice?.prenomDexercice || psGiven,
            s_name: exercice?.nomDexercice || psName,
            s_profession: exercice?.codeProfession,
            s_professionOid: professionOid,
            s_speciality: exercice?.codeSavoirFaire,
            PracticeLocations: [practiceLocation]
          } as any
        };
        return virtualSession;
      }

      if (!await this.isSessionOpen(type, connecteur) || (this._sessionsMap.get(type).sessionInfos.practiceSettingIndice === undefined || this._sessionsMap.get(type).sessionInfos.practiceSettingIndice === null)) {
        if (type && type !== SessionTypeEnum.CARTE && await this.isESConnexionIndirect(type)) {
          const loading = this._modalService.openLoading(view);
          try {
            await this._openSession(type);
          } catch (e) {
            this._modalService.openAlert(view,
              "Erreur",
              "Une erreur est survenue lors de la connexion en mode indirect. Veuillez réessayer ultérieurement.",
              undefined,
              e.toString());
          } finally {
            loading.destroy();
          }
        } else {
          try {
            const test = await this.showCpxModal(view, connecteur);
            if (!test.isSessionOpen) {
              return undefined;
            }
          } catch (e) {
            console.error(e);
            return undefined;
          }
        }
      }
      return this._sessionsMap.get(type).sessionInfos;
    } else if (connecteur ==  TypeConnecteurEnum.DINNO) {
      const isOpen = await this.isSessionOpen(type, connecteur);
      if (isOpen) {
        this.dinnoSession = await this._dinnoSessionSrv.getCurrentSession().toPromise();
        return this.dinnoSession;
      } else {
        const retourModale = await this.showCpxModal(view, connecteur)
        if (retourModale && retourModale.isSessionOpen) {
          return this.dinnoSession;
        }
      }
    } else {
      throw new Error('Connecteur non reconnu');
    }
  }

  public async isESConnexionIndirect(type: SessionTypeEnum) {
    if (type === SessionTypeEnum.CARTE) {
      return false;
    }

    const profil = (JSON.parse(localStorage.getItem('currentProfil')) as Profil);
    if (!profil || !profil.id) {
      return false;
    }

    const indirectType = type === SessionTypeEnum.CERT_DMP ? dmpTypeConnexionInteropSettingKey : insiTypeConnexionInteropSettingKey;

    const params = await this._resourceSrv.getResourceSettings(profil.id, 'profil');
    const typeConnexionInteropSetting = params.find(p => p.settingKey === indirectType);

    const isCertConnection = typeConnexionInteropSetting && typeConnexionInteropSetting.settingValue == "certificat_etablissement";

    if (isCertConnection) {
      if (profil.cabinet?.id) {
        if (type === SessionTypeEnum.CERT_DMP) {
          return (await this._userSrv.me())?.profil?.certificatDmpExists;
        } else if (type === SessionTypeEnum.CERT_INSI) {
          return (await this._userSrv.me())?.profil?.certificatInsiExists;
        }
      }
    } else {
      return false;
    }
  }

  private async isSessionInstanciate(type: SessionTypeEnum): Promise<boolean> {
    if (type !== SessionTypeEnum.CARTE) {
      return await new Promise<boolean>(async (resolve) => {
        if (await this._isDmpConnectSessionOpen(type)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      return await new Promise<boolean>(async (resolve) => {
        if (await this._isDmpConnectSessionOpen(type)) {
          this._sessionsMap.get(type)?.session?.hl_getSessionState(undefined, async (r) => {
            if (!await this.isWirelessMode(type)) {
              if (r.ConnectorPool && r.ConnectorPool.length > 0 && r.ConnectorPool[0]?.i_authToken > 0 && r.ConnectorPool[0]?.i_user > 0) {
                resolve(true);
              } else {
                resolve(false)
              }
            } else {
              resolve(true);
            }
          });
        } else {
          resolve(false);
        }
      });
    }
  }

  public async isSessionOpen(type: SessionTypeEnum, connecteur?: TypeConnecteurEnum): Promise<boolean> {
    if (!connecteur || connecteur == TypeConnecteurEnum.DMPConnect) {
      const isRest = await this._profilSrv.useEdcRestProxy();
      if (isRest && type === SessionTypeEnum.CARTE) {
        return !!this._edcAuthSrv.s_correlationId && this._edcAuthSrv.s_correlationId !== 'test-correlation-id';
      }
      return this._isDmpConnectSessionOpen(type);
    } else if (connecteur == TypeConnecteurEnum.DINNO) {
      try {
        const session = await this._dinnoSessionSrv.getCurrentSession().toPromise();
        if (session) {
          this.dinnoSession = session;
          return true;
        }
      } catch (e) {
        this.dinnoSession = undefined;
        return false;
      }
      return
    } else {
      return false;
    }
    // if (type === SessionTypeEnum.CERT_DMP || type === SessionTypeEnum.CERT_INSI) {
    //   return !!this._sessionsMap.get(type)?.getSessionId();
    // } else {
    //   return !!this._sessionsMap.get(type)?.getSessionId()
    //     && this._cpxSession
    //     && (this._cpxSession.cpxType === 'CPS' || this._cpxSession.cpxType === 'CPE');
    //     // && this._cpxSession.practiceSettingIndice !== undefined
    //     // && this._cpxSession.practiceSettingIndice !== null;
    // }
  }

  /**
   * Session DmpConnect locale réellement ouverte, indépendamment de l'API REST (Espace de Confiance).
   */
  private _isDmpConnectSessionOpen(type: SessionTypeEnum): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      try {
        if (type === SessionTypeEnum.CERT_DMP || type === SessionTypeEnum.CERT_INSI) {
          resolve(!!this._sessionsMap.get(type)?.session?.getSessionId());
        } else {
          const session = this._sessionsMap.get(type)?.session;
          const sessionInfos = this._sessionsMap.get(type)?.sessionInfos;
          const sessionId = session?.getSessionId();
          const cpxType = sessionInfos?.cpxType;
          const rtd = (!!sessionId
            && sessionInfos
            && (cpxType === 'CPS' || cpxType === 'CPE' || cpxType === 'CPF'));
          resolve(rtd);
        }
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  private _appendLog() {
    // console.log.apply(null, arguments);
  }

  private _wrapperInitialized(serverUrl) {
    if (!serverUrl)
    //  console.log("CPX Wrapper initialized");
    // console.log("Wrapper initialized. Server url is '" + serverUrl + "'");
    console.error("An error occurred during the wrapper initialization. ");
    // else
  }

  private _handleError(error, command, timeoutInSeconds, answerCallback) {
    console.error('Handled error', error);
    console.error('Command error', command);


    if (
      error
      && error.i_apiErrorCode === 3
      && error.i_apiErrorType === 6000
    ) {
      // this._resetSession(type);
    } else if (
      error
      && error.i_apiErrorCode === 2
      && error.i_apiErrorType === 5000
    ) {
      // this._resetSession(type);
      if (this._modal) {
        this._modal.instance.closeModal();
      }

      this._snckBrSrv.openSnackBar(
        'La carte CPS a été arrachée du lecteur',
        undefined,
        undefined,
        5000
      );
    }

    answerCallback({ 'error': error });
  }

  private _updateStateDisplay() {
    // var div = document.getElementById('appState');
    // div.innerHTML = "Session id: \"" + this._dmpConnectInstance.getSessionId() + "\"";

    // this.updateDisabledActions();
  }
  private _setCpxSession(type: CpxTypeEnum, name: string, pinCode: string, monitoring: WebSocket, practiceSetting: Array<CpxCardSignatureResponsePracticeLocationsInterface>, psGiven: string, psName: string, practiceSettingIndice?:number, sessionType: SessionTypeEnum = SessionTypeEnum.CARTE): void {

    if (sessionType === SessionTypeEnum.CARTE) {
      this._cpxCardType = type;
    }

    if (this._sessionsMap.get(sessionType).sessionInfos) {
      if (type) {
        this._sessionsMap.get(sessionType).sessionInfos.cpxType = type;
      }
      if (name) {
        this._sessionsMap.get(sessionType).sessionInfos.name = name;
      }
      if (pinCode) {
        this._sessionsMap.get(sessionType).sessionInfos.pinCode = pinCode;
      }
      if (monitoring) {
        this._sessionsMap.get(sessionType).sessionInfos.monitoring = monitoring;
      }
      if (practiceSetting) {
        this._sessionsMap.get(sessionType).sessionInfos.PracticeLocations = practiceSetting;
      }
      if (psGiven) {
        this._sessionsMap.get(sessionType).sessionInfos.psGiven = psGiven;
      }
      if (psName) {
        this._sessionsMap.get(sessionType).sessionInfos.psName = psName;
      }
      if (practiceSettingIndice || practiceSettingIndice === 0) {
        this._sessionsMap.get(sessionType).sessionInfos.practiceSettingIndice = practiceSettingIndice;
      }
    } else {
      const session = {};
      if (type) {
        session['cpxType'] = type;
      }
      if (name) {
        session['name'] = name;
      }
      if (pinCode) {
        session['pinCode'] = pinCode;
      }
      if (monitoring) {
        session['monitoring'] = monitoring;
      }
      if (practiceSetting) {
        session['PracticeLocations'] = practiceSetting;
      }
      if (psGiven) {
        session['psGiven'] = psGiven;
      }
      if (psName) {
        session['psName'] = psName;
      }
      if (practiceSettingIndice || practiceSettingIndice === 0) {
        session['practiceSettingIndice'] = practiceSettingIndice;
      }
      this._sessionsMap.get(sessionType).sessionInfos = session as any;
    }
  }

  private async _getCertificatEtablissement(type?: SessionTypeEnum): Promise<string | undefined> {
    return new Promise<string | undefined>(async (resolve, reject) => {
      try {
        let rtd: string;
        if (type === SessionTypeEnum.CERT_DMP) {
          rtd = await this._userSrv.getCertificatEtablissement("DMP");
        } else if (type === SessionTypeEnum.CERT_INSI) {
          rtd = await this._userSrv.getCertificatEtablissement("INSI");
        } else {
          return undefined;
        }
        resolve(rtd);
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  private async _openSession(type?: SessionTypeEnum, connecteur?: TypeConnecteurEnum): Promise<any> {
    try {
      if (!connecteur || connecteur == TypeConnecteurEnum.DMPConnect) {
        if (!await this.isSessionOpen(type, connecteur)) {
          return await new Promise<any>(async (resolve, reject) => {
            const dcParam = environment.cpxLicenseBase64;
            try {
              if(type && type !== SessionTypeEnum.CARTE && await this.isESConnexionIndirect(type)) {
                const result = await this._getInstanceByType(type);
                resolve(result);
              } else {
                const result = await this._getInstanceByType(SessionTypeEnum.CARTE);
                resolve(result);
              }
            } catch (e) {
              reject(e);
            }
          });
        }
      } else if (connecteur == TypeConnecteurEnum.DINNO) {
        if (!await this.isSessionOpen(type, connecteur)) {
          return await this._getInstanceByType(type, connecteur);
        }
      }
    } catch (e) {
      throw e;
    }
  }

  private async _getPcscReaders(type: SessionTypeEnum): Promise<any> {
    return await new Promise<any>(async (resolve, reject) => {
      (await this._getInstanceByType(type)).hl_getPcscReaders((response) => {
        if (response.error) {
          if (this.isErrorEndSession(response, type)) {
            reject(new DoRetryError());
          } else {
            reject(response.error);
          }
        } else {
          resolve(response);
        }
      });
    })
  }

  private async _getNBVitaleCard(readers: any): Promise<any> {
    let res = {
      vitale: 0,
      cps: 0,
    }

    if (await this.isWirelessMode(SessionTypeEnum.CARTE) && readers.find(r => r.s_name === WIRELESS_MODE_VITALE_CARD_NAME)) {
      res = {
        vitale: readers.find(r => r.s_name === WIRELESS_MODE_VITALE_CARD_NAME) ? 1 : 0,
        cps: readers.find(r => r.s_name === WIRELESS_MODE_CPX_CARD_NAME) ? 1 : 0,
      }
    } else {
      for (let reader of readers) {
        if (reader.i_slotType === 2) {
          res.vitale++;
        } else if (reader.i_slotType === 3) {
          res.cps++;
        }
      }
    }

    return res;
  };

  private async _getVitaleCards(readers: any): Promise<Array<any>> {
    let cards = [];

    if (await this.isWirelessMode(SessionTypeEnum.CARTE)) {
      const wirelessVitale = readers.find(r => r.s_name === WIRELESS_MODE_VITALE_CARD_NAME);
      if (wirelessVitale) {
        cards.push(wirelessVitale);
      }
    } else {
      for (let reader of readers) {
        if (reader.i_slotType === 2) {
          cards.push(reader);
        }
      }
    }
    return cards;
  };

  private _getCpxCards(readers: Array<any>): Array<any> {
    const cpxCards: Array<any> = [];

    if (this._isWirelessModeVar) {
      for (const c of readers) {
        if (c.s_name === WIRELESS_MODE_CPX_CARD_NAME) {
          cpxCards.push(c);
          break;
        }
      }
    } else {
      for (const c of readers) {
        if (c.i_slotType === 3) {
          cpxCards.push(c);
        }
      }
    }

    return cpxCards;
  }

  private _getIndexLecteur(readers: any, name: string) {
    let index = 0;
    for (let reader of readers) {
      if (reader.s_name === name) {
        return index;
      }
      index++;
    }
    return -1;
  };

  // private async _getSessionForVitaleCall(): Promise<any> {
  //   const isEs = await this.isESConnexionIndirect(SessionTypeEnum.CERT_INSI);
  //   let type = SessionTypeEnum.CARTE;
  //   if (isEs) {
  //     type = SessionTypeEnum.CERT_INSI;
  //   }
  //   return await this._getInstanceByType(type);
  // }

  private async _setVitaleCard(name: string, index: number, type: SessionTypeEnum) {
    return await new Promise<any>(async (resolve, _) => {
      (await this._getInstanceByType(type)).hl_getVitaleCard(index, name, (response) => {
        resolve(response);
      });
    });
  };

  private async _read(type: SessionTypeEnum): Promise<LectureCarteVitale> {
    return await new Promise<any>(async (resolve, reject) => {
      if (type === SessionTypeEnum.CARTE && await this.isWirelessMode(type)) {
        try {
          const updateVitaleTokenOk = await this._updateVitaleAuthenticationToken(type);
          if (!updateVitaleTokenOk) {
            reject(new Error('Impossible de mettre à jour le token d\'authentification'));
          }
        } catch (e) {
          reject(e);
        }
      }

      (await this._getInstanceByType(type)).hl_readVitaleCard((response) => {
        resolve(response);
      });
    });
  }

  private async _updateVitaleAuthenticationToken(type: SessionTypeEnum): Promise<boolean> {
    return await new Promise<any>(async (resolve, reject) => {
      try {
        const accessToken = await this._stellairSrv.getStellairAccessToken();
        if (!accessToken || accessToken === '') {
          throw new Error('Impossible de récupérer le token d\'authentification');
        }

        (await this._getInstanceByType(type)).hl_updateVitaleAuthenticationToken(accessToken, (response) => {
          resolve(response);
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  private async hl_createEsTlsiConnector(
    cpxInstance:any,
    tlsiServerUrl: string,
    transactionsTimeoutInSeconds: number,
    hpParam: any,
    practiceLocation: any,
    optionalParameters : {}, resultCallback : (response: any) => void
  ) {
    // Récupération des infos utilisateurs

    // Récupération des infos PracticeLocation


    var serverUrl = "";
    // Empty string => qualification server.
    if( tlsiServerUrl === "" )
        serverUrl = "https://qualiflps-services-ps-tlsm.ameli.fr";
    else
        serverUrl = tlsiServerUrl;

    var command = {
        "s_commandName"               : "hl_createEsTlsiConnector",
        "s_tlsiUrl"                   : serverUrl,
        "i_transactionsTimeout"       : transactionsTimeoutInSeconds,
        "i_getConnectionHandle"       : 1,
        "PracticeLocation"            : practiceLocation,
        "Hp"                          : hpParam,
        "s_sessionId"                 : cpxInstance.getSessionId()
    };

    // Merge the HTTP proxy parameters and/or the NTP proxy parameters set in optionalParameters.
    if( optionalParameters )
    {
        for( var p in optionalParameters )
        {
            command[ p ] = optionalParameters[ p ];
        }
    }

    // Get connection handle
    return cpxInstance.sendCommand( command, 20, resultCallback );
  }

  private async createInsiConnector(view: ViewContainerRef, resourceId: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      const isEs = await this.isESConnexionIndirect(SessionTypeEnum.CERT_INSI);
      let type = SessionTypeEnum.CARTE;
      if (isEs) {
        type = SessionTypeEnum.CERT_INSI;
      }

      if (!await this.getCpxSession(view, type)) {
        resolve(false);
      }

      try {
        let practiceSettingValue: string;
        const params = await this._resourceSrv.getResourceSettings(resourceId, 'profil');
        if (params) {
          for (const param of params) {
            if (param.settingKey === practiceSettingKey) {
              practiceSettingValue = param.settingValue;
            }
          }
        } else {
          throw {
            message: 'Les paramètres de DMP sont manquants'
          };
        }

        if (!practiceSettingValue || practiceSettingValue === '') {
          throw {
            message: 'Le cadre d\'exercice n\'est pas renseigné dans les paramètres'
          };
        }

        const cpxInstance = await this.getInstance(view, type);
        // On ouvre une connexion INSI avec DMPConnect
        if (isEs) {
          let professionSettingParam: string;
          let specialiteSettingParam: string;
          let nomSettingParam: string;
          let prenomSettingParam: string;
          let nomStructureSettingParam: string;
          let typeStructureSettingParam: string;
          let professionSettingOid: string;

          let professionsRef=[];
          const professionSettingsArrTmp = await this._refSrv.findRefListTableHypermed("RefSubjectRoleDMP");
          for (const ps of professionSettingsArrTmp) {
            professionsRef.push({
              id: ps.id.split('++')[0],
              oid : ps.sublibelle,
              libelle: ps.libelle
            });
          }

          const professionSetting = params.find(p => p.settingKey === professionSettingKey);
          if (professionSetting && professionSetting.settingValue !== '') {
            professionSettingParam = professionSetting.settingValue;
            professionSettingOid = professionsRef.find(p => p.id === professionSettingParam).oid;
          } else {
            throw {
              message: 'La profession n\'est pas renseignée dans les paramètres'
            };
          }

          const specialiteSetting = params.find(p => p.settingKey === specialiteSettingKey);
          if (specialiteSetting && specialiteSetting.settingValue !== '') {
            specialiteSettingParam = specialiteSetting.settingValue;
          } else {
            throw {
              message: 'La spécialité n\'est pas renseignée dans les paramètres'
            };
          }
          const nomSetting = params.find(p => p.settingKey === nomSettingKey);
          if (nomSetting && nomSetting.settingValue !== '') {
            nomSettingParam = nomSetting.settingValue;
          } else {
            throw {
              message: 'Le nom n\'est pas renseignée dans les paramètres'
            };
          }
          const prenomSetting = params.find(p => p.settingKey === prenomSettingKey);
          if (prenomSetting && prenomSetting.settingValue !== '') {
            prenomSettingParam = this._strUtilsSrv.uppercaseFirstCharString(prenomSetting.settingValue);
          } else {
            throw {
              message: 'Le prénom n\'est pas renseignée dans les paramètres'
            };
          }

          const nomStructureSetting = params.find(p => p.settingKey === nomStructureSettingKey);
          if (nomStructureSetting && nomStructureSetting.settingValue !== '') {
            nomStructureSettingParam = nomStructureSetting.settingValue;
          } else {
            throw {
              message: 'Le nom de structure n\'est pas renseignée dans les paramètres'
            };
          }
          const typeStructureSetting = params.find(p => p.settingKey === typeStructureSettingKey);
          if (typeStructureSetting && typeStructureSetting.settingValue !== '') {
            typeStructureSettingParam = typeStructureSetting.settingValue;
          } else {
            throw {
              message: 'Le type de structure n\'est pas renseignée dans les paramètres'
            };
          }

          const hpParam = {
            s_hpName: nomSettingParam,
            s_hpGiven: prenomSettingParam,
            s_hpProfession: professionSettingParam,
            s_hpProfessionOid: professionSettingOid,
            s_hpSpeciality: specialiteSettingParam,
            s_hpInternalId: resourceId,
            i_hpAuthenticationMode: 9
          };
          const practiceLocation = {
            s_practiceLocationName: nomStructureSettingParam,
            s_practiceLocationActivitySector: typeStructureSettingParam,
            s_practiceLocationPracticeSettings: practiceSettingValue,
          };

          this.hl_createEsTlsiConnector(
            cpxInstance,
            environment.tlsiServerEsUrl,
            60,
            hpParam,
            practiceLocation,
            {},                // Paramètres optionnels
            (response) => {
              if (response.s_status === 'OK') {
                  resolve(true);
              } else {
                  if (this.isErrorEndSession(response, type)) {
                      reject(new DoRetryError());
                  } else {
                      reject(response.error);
                  }
              }
          });
        } else {
          const cpsSession = await this.getCpxSession(view, type);
          if (cpsSession.practiceSettingIndice === undefined || cpsSession.practiceSettingIndice === null) {
            throw {
              message: 'Le lieux d\'exercice n\'a pas été renseigné'
            };
          }

          cpxInstance.hl_createInsiConnector(
            this._sessionsMap.get(type).sessionInfos.pinCode,
            'https://qualiflps.services-ps.ameli.fr',
            60,
            practiceSettingValue,
            this._sessionsMap.get(type).sessionInfos.practiceSettingIndice,
            {},
            (response) => {
                if (response.s_status === 'OK') {
                    resolve(true);
                } else {
                    if (this.isErrorEndSession(response, type)) {
                        reject(new DoRetryError());
                    } else {
                        reject(response.error);
                    }
                }
            }
          );
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * On utilise cette méthode pour faire une "empreinte" d'une CV
   */
  private _serializeVitale(obj: any): string {
    if (Array.isArray(obj)) {
      return JSON.stringify(obj.map(i => this._serializeVitale(i)));
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.keys(obj)
        .sort()
        .map(k => `${k}:${this._serializeVitale(obj[k])}`)
        .join('|');
    }

    return obj;
  }

  private async _checkIfLastVitaleIsTheSame(type: SessionTypeEnum): Promise<boolean> {
    const checkCv = await this._cvStatus(type);

    if (checkCv && checkCv.i_cardStatus != 6 && checkCv.i_cardStatus != 2) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * @deprecated Utiliser InsServiceAbstract.getInsFromVitaleCard, qui applique le choix websocket / API REST.
   */
  public async getInsFromVitale(view: ViewContainerRef, resourceId: string, vitaleIndex: number): Promise<LectureIns> {
    return new Promise<LectureIns>(async (resolve, reject) => {
        let type = SessionTypeEnum.CARTE;
        try {
          if (await this.isESConnexionIndirect(SessionTypeEnum.CERT_INSI)) {
            type = SessionTypeEnum.CERT_INSI
          }
        } catch (e) {
          reject(e);
          return;
        }

        try {
          if (!this._vitaleLectureInfos) {
            this.modalSuppInfos = 'La carte Vitale est différente.\nVous devez de nouveau vous authentifier pour accéder aux informations détaillées de ce patient.';
          }

          if (!await this._checkIfLastVitaleIsTheSame(type)) {
            this.modalSuppInfos = 'La carte Vitale est différente.\nVous devez de nouveau vous authentifier pour accéder aux informations détaillées de ce patient.';
          }
        } catch (e) {
          /**
           * Si on entre dans ce catch c'est parce que
           * la CV utilisée pour lister les patient
           * et la CV utilisée pour sélectionner un patient
           * ne sont pas les mêmes (l'utilisateur a changé de carte entre le listage et la sélection)
           * Dans ce cas on ne continue pas le processus de hl_getInsFromVitaleCard :
           * - on remonte une erreur de type NotSameVitaleCard (pour avertir le controlleur du type de problème rencontré)
           * - on clos la session pour forcer l'utilisateur à ouvrir une nouvelle session pour les prochains accès
           * - on passe les propriétés de _lastVitaleRead à undefined pour repartir à 0 concernant la dernière CV insérée
           */
          console.error(e);
          await this.closeSession(type);
          reject(new NotSameVitaleCard());
          return;
        }

        try {
          const open = await this.isSessionOpen(type);
          if (!open) {
            resolve(undefined);
            return;
          }
          const create = await this.createInsiConnector(view, resourceId);
          if (!create) {
            resolve(undefined);
            return;
          }
        } catch (e) {
            console.error(e);
            if (e instanceof DoRetryError) {
              resolve(await this.getInsFromVitale(view, resourceId, vitaleIndex));
            } else {
              reject(new CannotCreateInsiConnector());
            }
        }

        try {
         
            (await this._getInstanceByType(type)).hl_getInsFromVitaleCard(
              this.LpsInfos,
              vitaleIndex,
              (response) => {
                const requeteInfo = `\n\nRequête: hl_getInsFromVitaleCard\nParamètres:\nLpsInfos : ${this.LpsInfos.s_name}:${this.LpsInfos.s_version}\nVitaleIndex : ${vitaleIndex}`;
                if (response.i_insIdentityResult === 1) {
                  this._addLog(DomainEnum.Insi, { action: ActionEnum.Read, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Récupération de l\'INS depuis la carte Vitale', details: 'Retour :\n01 - aucune identité n\'a été trouvée' + requeteInfo });
                  reject(new NoIdentityFound());
                  return;
                } else if (response.i_insIdentityResult === 3) {
                  this._addLog(DomainEnum.Insi, { action: ActionEnum.Read, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Récupération de l\'INS depuis la carte Vitale', details: 'Retour :\n02 - plusieurs identités ont été trouvées' + requeteInfo });
                  reject(new MultipleIdentitiesFound());
                  return;
                }
                if (response.s_status === 'OK') {
                    resolve(response);
                    let details = `Retour :\n00 - une identité unique a été trouvée\n`;
                    details += `Nom de naissance : ${(response as LectureIns).Identity?.s_birthName || 'Inconnu'}\n`;
                    details += `Prénom de naissance : ${(response as LectureIns).Identity?.s_birthGiven || 'Inconnu'}\n`;
                    details += `Date de naissance : ${(response as LectureIns).Identity?.s_birthDate || 'Inconnue'}\n`;
                    details += `Sexe : ${this._getSexName(response)}\n`;
                    details += `Lieu de naissance : ${(response as LectureIns).Identity?.s_birthPlace || 'Inconnu'}\n`;
                    if ((response as LectureIns).Identity?.Ins?.s_oid && (response as LectureIns).Identity?.Ins?.s_value && (response as LectureIns).Identity?.Ins?.s_key) {
                      details += `${this._getInsLabel((response as LectureIns).Identity?.Ins?.s_oid)} : ${(response as LectureIns).Identity?.Ins?.s_value} ${(response as LectureIns).Identity?.Ins?.s_key} (${(response as LectureIns).Identity?.Ins?.s_oid})`;
                    }
                    if ((response as LectureIns).Identity?.History) {
                      let historyStr = '\nHistorique INS : ';
                      for (const h of (response as LectureIns).Identity.History) {
                          historyStr += `\n- ${this._getInsLabel(h.s_oid)} : ${h.s_value} ${h.s_key} (${h.s_oid}) / Du ${h.s_startDate} au ${h.s_endDate}`;
                      }
                      details += `\n${historyStr}`;
                    }
                    const requeteInfo = `\n\nRequête: hl_getInsFromVitaleCard\nParamètres:\nLpsInfos : ${this.LpsInfos.s_name}:${this.LpsInfos.s_version}\nVitaleIndex : ${vitaleIndex}`;
                    details += requeteInfo;
                    
                    this._addLog(DomainEnum.Insi, { action: ActionEnum.Read, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Récupération de l\'INS depuis la carte Vitale', details: details });
                } else {
                    reject(response.error);
                    const detailsArr = [];
                    if (response.error.s_apiErrorDescription) {
                        detailsArr.push(`Description : ${response.error.s_apiErrorDescription}`);
                    }
                    if (response.error.s_apiErrorTlsiErrorDetailCode) {
                        detailsArr.push(`Détail code : ${response.error.s_apiErrorTlsiErrorDetailCode}`);
                    }
                    if (response.error.s_apiErrorTlsiErrorDetailError) {
                        detailsArr.push(`Détail : ${response.error.s_apiErrorTlsiErrorDetailError}`);
                    }
                    if (response.error.s_apiErrorExtendedInformations) {
                        detailsArr.push(`Informations supplémentaires : ${response.error.s_apiErrorExtendedInformations}`);
                    }
                    const requeteInfo = `\n\nRequête: hl_getInsFromVitaleCard\nParamètres:\nLpsInfos : ${this.LpsInfos.s_name}:${this.LpsInfos.s_version}\nVitaleIndex : ${vitaleIndex}`;
                    this._addLog(DomainEnum.Insi, { action: ActionEnum.Read, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Récupération de l\'INS depuis la carte Vitale', details: 'Retour :\n' + detailsArr.join('\n') + requeteInfo });
                }
              }
            );
          
        } catch (e) {
            reject(e);
        }
    });
  }

  private _getSexName(patientIns: LectureIns) {
    let sexName: string;
    switch (patientIns.Identity.i_sex) {
      case 2: {
        sexName = "Masculin";
        break;
      }
      case 3: {
        sexName = "Féminin";
        break;
      }
      default: {
        sexName = "Inconnu";
        break;
      }
    }
    return sexName;
  }

  private _getInsLabel(oid: string): string {
      switch (oid) {
          case '1.2.250.1.213.1.4.8':
              return 'INS-NIR';
          case '1.2.250.1.213.1.4.9':
              return 'INS-NIA';
          case '1.2.250.1.213.1.4.10':
              return 'INS-NIR de test';
          case '1.2.250.1.213.1.4.11':
              return 'INS-NIR de démonstration';
          default:
              return 'INS';
      }
  }

  private async _readVitaleCard(readers: any, name: string, type: SessionTypeEnum): Promise<LectureCarteVitale> {
    this._lastVitaleRead = undefined;
    const index = this._getIndexLecteur(readers, name);
    if (index === -1) {
      throw new VitaleCardRipped();
    }
    await this._setVitaleCard(name, index, type);
    const result = await this._read(type);
    if (result["s_status"] != "OK") {
      throw new CannotReadVitale();
    }
    this._lastVitaleRead = result;
    if (this._sessionsMap.get(type).sessionInfos) {
      this._sessionsMap.get(type).sessionInfos.cardStatus = result.i_cardStatus;
      this._sessionsMap.get(type).sessionInfos = this._sessionsMap.get(type).sessionInfos;
    }
    await this._cvStatus(type);
    return result;
  };

  private async _readCpxCard(slots: Array<any>, name: string): Promise<any> {
    const index = this._getIndexLecteur(slots, name);
    if (index === -1) {
      throw new CpxCardRipped();
    }

    const statusOk = await this._getCpxCard(name, index);
    if (statusOk.s_status === 'OK') {
      return slots.find(s => s.s_name === name);
    } else {
      throw new CannotReadCpx();
    }
  }

  private gettedCpxCard: Map<string, any> = new Map<string, any>();
  private async _getCpxCard(name: string, index: number): Promise<any> {
    return await new Promise<any>(async (resolve, _) => {
      if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos && this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring) {
        this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring.close();
        this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring = undefined;
        this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;
      }

      const isWireless = await this.isWirelessMode(SessionTypeEnum.CARTE);
      if (isWireless) {
        index = undefined;
      }

      (await this._getInstanceByType(SessionTypeEnum.CARTE)).hl_getCpxCard(index, name, (response) => {
      if (response?.error) {
        if (this.isErrorEndSession(response, SessionTypeEnum.CARTE)) {
          resolve(new DoRetryError());
        } else {
          resolve(response.error);
        }
        return;
      }
      // ✅ on met à jour le cache mais on ne court-circuite plus l'appel
      this.gettedCpxCard.set(name, response);
      resolve(response);
    });

      // if (this.gettedCpxCard.has(name)) {
      //   resolve(this.gettedCpxCard.get(name));
      // } else {
      //   (await this._getInstanceByType(SessionTypeEnum.CARTE)).hl_getCpxCard(index, name, (response) => {
      //     if (response.error) {
      //       if (this.isErrorEndSession(response, SessionTypeEnum.CARTE)) {
      //         resolve(new DoRetryError());
      //       } else {
      //         resolve(response.error);
      //       }
      //     } else {
      //       this.gettedCpxCard.set(name, response);
      //       resolve(response);
      //     }
      //   });
      // }
    });
  }

  private _getCardTypeLabel(type: number): string {
    const strArr: Array<string> = [];
    const indexArr: Array<number> = [];

    Object.keys(CpxCardTypeEnum).filter((v: any) => {
      if (isNaN(Number(v))) {
        strArr.push(v);
      } else {
        indexArr.push(Number(v));
      }
    });

    return strArr[indexArr.findIndex(i => i === type)];
  }

  private _startMonitoring(): WebSocket {
    if (this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos && this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring) {
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring.close();
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos.monitoring = undefined;
      this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos;
    }

    let errorHappened = false;
    if (!this._sessionsMap.get(SessionTypeEnum.CARTE)) {
      return;
    }
    let monitoring = this._sessionsMap.get(SessionTypeEnum.CARTE).session.hl_startCpxCardMonitoring(3, (receivedObject, responseCallback) => {
      if (errorHappened) {
        return;
      }

      if (receivedObject.error) {
        errorHappened = true;
        this.cpxCardRipped.emit(CardRippedStatus.dmpConnectError);
        this._sessionsMap.get(SessionTypeEnum.CARTE).sessionInfos = undefined;
        this.cardInfos = undefined;
        monitoring.close();
        monitoring = undefined;
        this.gettedCpxCard.clear();
      } else {
        if (receivedObject.i_cardStatus === 2) {
          errorHappened = true;
          this.cpxCardRipped.emit(CardRippedStatus.rippedCard);
          monitoring.close();
          monitoring = undefined;
          this.gettedCpxCard.clear();


          this._resetSession(SessionTypeEnum.CARTE);
          if (this._modal) {
            this._modal.instance.closeModal();
          }

          this._snckBrSrv.openSnackBar(
            'La carte CPS a été arrachée du lecteur',
            undefined,
            undefined,
            5000
          );
        }

        responseCallback(true);
      }
    });

    return monitoring;
  }

  public async closeSession(type: SessionTypeEnum): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {

      if (!await this.isSessionOpen(type)) {
        resolve();
        return;
      }

      this._sessionsMap.get(type).session.hl_closeSession((res) => {
        if (res && res.error) {
          if (res.error.s_apiErrorExtendedInformations) {
            reject({ message: res.error.s_apiErrorExtendedInformations });
          } else {
            reject({ message: 'Une erreur est survenue lors de la fermeture de session de DmpConnect' });
          }
        } else {
          if (type === SessionTypeEnum.CARTE) {
            this.cardInfos = undefined;
          }
          this._resetSession(type);
          resolve();
        }
      });
    });
  }

  private _resetSession(type: SessionTypeEnum): void {
    // this._cpxSession = undefined;
    this._sessionsMap.delete(type);

    if (this._vitaleLectureInfos?.type === type) {
      this._lastVitaleRead = undefined;
    }

    if (type === SessionTypeEnum.CARTE) {
      this._sessionsMap.set(SessionTypeEnum.CARTE, { session: this._getNewDmpInstance(SessionTypeEnum.CARTE), sessionInfos: undefined });
    } else if (type === SessionTypeEnum.CERT_DMP) {
      this._sessionsMap.set(SessionTypeEnum.CERT_DMP, { session: this._getNewDmpInstance(SessionTypeEnum.CERT_DMP), sessionInfos: undefined });
    } else if (type === SessionTypeEnum.CERT_INSI) {
      this._sessionsMap.set(SessionTypeEnum.CERT_INSI, { session: this._getNewDmpInstance(SessionTypeEnum.CERT_INSI), sessionInfos: undefined });
    }
  }

  private _getNewDmpInstance(type: SessionTypeEnum): any {
    if (type === SessionTypeEnum.CARTE) {
      return new DMPConnect(this._appendLog.bind(this), this._updateStateDisplay.bind(this), this._handleError.bind(this), this._wrapperInitialized, "9982", "localhost.icanopee.net");
    } else if (type === SessionTypeEnum.CERT_DMP) {
      return new DMPConnect(this._appendLog, this._updateStateDisplay, this._handleError.bind(this), this._wrapperInitialized, "9982", "localhost.icanopee.net");
    } else if (type === SessionTypeEnum.CERT_INSI) {
      return new DMPConnect(this._appendLog, this._updateStateDisplay, this._handleError.bind(this), this._wrapperInitialized, "9982", "localhost.icanopee.net");
    }
  }

  private async _addLog(domain: DomainEnum, obj: LogObject): Promise<void> {
    const logSrv = this._logSrv.getConfiguration(domain);
    if (logSrv) {
      logSrv.addLog(obj);
    }
  }

  public isErrorEndSession(error: any, type: SessionTypeEnum): boolean {
    if (
      (error.error && error.error.i_apiErrorCode === 3 && error.error.i_apiErrorType === 6000)
      || (error.i_apiErrorCode === 3 && error.i_apiErrorType === 6000)
    ) {
      this._resetSession(type);
      return true;
    } else {
      return false;
    }
  }
}

const dinnoSessionServiceFactory = (
  httpClient: HttpClient,
) => {
  return new SessionService(httpClient, environment.dinnoConnectorUrl, null);
};

export const dinnoSessionProvider: Provider = {
  provide: SessionService,
  useFactory: dinnoSessionServiceFactory,
  deps: [
    HttpClient
  ]
};
